import React from 'react';

import { SimpleObject } from '@clearverify/types';

import { Modal } from 'src/components/common';
import { EmployerStaffDetailsModalForm } from 'src/components/employer';
import { ModalId } from 'src/constants/modals';
import { useModal } from 'src/hooks/shared';

export interface EmployerStaffDetailsModalArgs extends SimpleObject {
  employerStaffId: string;
}

export const EmployerStaffDetailsModal: React.FC = () => {
  const { closeModal, switchClosability, isOpen, args } = useModal<EmployerStaffDetailsModalArgs>(
    ModalId.EmployerStaffDetailsModal,
  );

  const handleCloseModal = React.useCallback(() => {
    closeModal();
  }, [closeModal]);

  return (
    <Modal
      title="Staff Details"
      dialogProps={{
        onClose: handleCloseModal,
        open: isOpen,
      }}
      maxWidth={600}
      headerPadding="32px 32px 8px 32px"
    >
      <EmployerStaffDetailsModalForm
        employerStaffId={args?.employerStaffId}
        onCloseModal={handleCloseModal}
        switchClosability={switchClosability}
      />
    </Modal>
  );
};
